import React, {useEffect, useState} from 'react';
import './viewNews.scss';

import {useNavigate, useParams} from "react-router-dom";
import {Button} from 'components';
import {NewsDataTypes} from 'models';
import {newsData} from "../../../../data/newsData";
import {useGetArticles} from "../../../../operations/queries/useGetArticles";
import { escapeHtml } from 'util/removeHtmlFromString';

const ViewNews = () => {
    let {newsId} = useParams();
    const [news, setNews] = useState<NewsDataTypes>();
    const navigate = useNavigate();

    const {data: articleData} = useGetArticles();
    const [articles, setArticles] = useState<Array<NewsDataTypes>>([])

    useEffect(() => {
        if (!articleData) return
        let articleList: Array<NewsDataTypes> = [];

        articleData.forEach((article: any) => {
            const articleInfo = article.attributes

            articleList.push({
                id: article.id,
                date: articleInfo.date?.split("T")[0],
                image: process.env.REACT_APP_BASE_URL + articleInfo.image.data.attributes.url,
                author: articleInfo.author,
                heading: articleInfo.heading,
                description: articleInfo.description,
                body: escapeHtml(articleInfo.body),
                link: articleInfo?.link ?? "N/A",
                isPopular: articleInfo?.isPopular ?? 'N/A',
                headerImage: process.env.REACT_APP_BASE_URL + articleInfo.headerImage.data.attributes.url
            })
        })
        setArticles(articleList)
    }, [articleData]);

    useEffect(() => {
        setNews(articles.filter((data) => (data.id === newsId))[0]);
    }, [newsId, news])

    return (
        <div className={'view-news'} id={'view-news'}>
            <div className={'view-news_wrapper max'}>
                <img src={news?.headerImage} alt=""/>
                <h1>{news?.heading}</h1>
                <span id="date">{news?.date}</span>
                <span id="author">By: {news?.author} courtesy of SBAJ</span>

                <div className="view-news_wrapper_sections">

                    {news?.body}
                </div>


                <div className={'view-news_wrapper_cta'}>
                    <Button text={'View More Articles'} type={'primary'} onclick={() => navigate('/news')}/>
                    <Button text={'Back'} type={'secondary'} onclick={() => navigate(-1)}/>
                </div>
            </div>
        </div>
    );
};

export default ViewNews;
